import styled from "styled-components";

import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const CurrentTagsSection = styled(Stack)`
    gap: 12px;
`;

export const ChipsContainer = styled(Flex)`
    flex-wrap: wrap;
    column-gap: 4px;
    max-height: 162px; /* 4 rows */
    overflow-y: auto;
`;